// extracted by mini-css-extract-plugin
export default {"readOnly":"de8Yfv","disabled":"nyN6Yi"};